// src/lib/sample-data/plan-history.ts

import type { PlanHistoryEntry, PlanChangeType, PlanChangeInitiator } from '@/lib/types';
import { sampleOrganizationDataForAccountPage } from './organizations';

export const samplePlanHistoryData: PlanHistoryEntry[] = [
  {
    id: '1',
    organizationId: sampleOrganizationDataForAccountPage.id,
    timestamp: '2024-01-15T14:30:00Z',
    changeType: 'PLAN_UPGRADED' as PlanChangeType,
    previousPlanId: 'starter-plan-id',
    previousPlanName: 'Starter',
    newPlanId: 'advanced-plan-id',
    newPlanName: 'Advanced',
    previousPrice: '29',
    newPrice: '89',
    priceChange: '+60',
    currencyCode: 'CHF',
    billingCycle: 'Monthly',
    changedBy: 'Sarah Johnson (Super Admin)',
    changedByUid: 'sarah-johnson-uid',
    initiator: 'SUPER_ADMIN' as PlanChangeInitiator,
    effectiveDate: '2024-01-15T14:30:00Z',
    previousBillingDate: '2024-01-20T00:00:00Z',
    newBillingDate: '2024-02-15T00:00:00Z',
    dateCreated: '2024-01-15T14:30:00Z',
    dateUpdated: '2024-01-15T14:30:00Z'
  },
  {
    id: '2',
    organizationId: sampleOrganizationDataForAccountPage.id,
    timestamp: '2023-12-20T16:45:00Z',
    changeType: 'GRACE_PERIOD_ADDED' as PlanChangeType,
    previousPlanId: 'advanced-plan-id',
    previousPlanName: 'Advanced',
    newPlanId: 'advanced-plan-id',
    newPlanName: 'Advanced',
    previousPrice: '89',
    newPrice: '89',
    priceChange: '0',
    currencyCode: 'CHF',
    billingCycle: 'Monthly',
    changedBy: 'System',
    initiator: 'SYSTEM' as PlanChangeInitiator,
    effectiveDate: '2023-12-20T16:45:00Z',
    previousBillingDate: '2023-12-25T00:00:00Z',
    newBillingDate: '2024-02-25T00:00:00Z',
    gracePeriodAdded: 2,
    notes: 'Applied during holiday promotion period',
    dateCreated: '2023-12-20T16:45:00Z',
    dateUpdated: '2023-12-20T16:45:00Z'
  },
  {
    id: '3',
    organizationId: sampleOrganizationDataForAccountPage.id,
    timestamp: '2023-11-08T09:15:00Z',
    changeType: 'PLAN_ASSIGNED' as PlanChangeType,
    newPlanId: 'starter-plan-id',
    newPlanName: 'Starter',
    previousPrice: '0',
    newPrice: '29',
    priceChange: '+29',
    currencyCode: 'CHF',
    billingCycle: 'Monthly',
    changedBy: 'Michael Chen (Super Admin)',
    changedByUid: 'michael-chen-uid',
    initiator: 'SUPER_ADMIN' as PlanChangeInitiator,
    effectiveDate: '2023-11-08T09:15:00Z',
    newBillingDate: '2023-12-08T00:00:00Z',
    notes: 'First plan assignment - organization was previously unassigned',
    dateCreated: '2023-11-08T09:15:00Z',
    dateUpdated: '2023-11-08T09:15:00Z'
  },
  {
    id: '4',
    organizationId: sampleOrganizationDataForAccountPage.id,
    timestamp: '2024-02-28T11:20:00Z',
    changeType: 'BILLING_UPDATED' as PlanChangeType,
    previousPlanId: 'advanced-plan-id',
    previousPlanName: 'Advanced',
    newPlanId: 'advanced-plan-id',
    newPlanName: 'Advanced',
    previousPrice: '89',
    newPrice: '89',
    priceChange: '0',
    currencyCode: 'CHF',
    billingCycle: 'Monthly',
    changedBy: 'Jennifer Lopez (Super Admin)',
    changedByUid: 'jennifer-lopez-uid',
    initiator: 'SUPER_ADMIN' as PlanChangeInitiator,
    effectiveDate: '2024-02-28T11:20:00Z',
    previousBillingDate: '2024-03-15T00:00:00Z',
    newBillingDate: '2024-03-01T00:00:00Z',
    notes: 'Billing date moved to beginning of month as requested',
    dateCreated: '2024-02-28T11:20:00Z',
    dateUpdated: '2024-02-28T11:20:00Z'
  },
  {
    id: '5',
    organizationId: sampleOrganizationDataForAccountPage.id,
    timestamp: '2024-03-10T13:45:00Z',
    changeType: 'PLAN_DOWNGRADED' as PlanChangeType,
    previousPlanId: 'enterprise-plan-id',
    previousPlanName: 'Enterprise',
    newPlanId: 'advanced-plan-id',
    newPlanName: 'Advanced',
    previousPrice: '199',
    newPrice: '89',
    priceChange: '-110',
    currencyCode: 'CHF',
    billingCycle: 'Monthly',
    changedBy: 'David Wilson (Admin)',
    changedByUid: 'david-wilson-uid',
    initiator: 'ADMIN' as PlanChangeInitiator,
    effectiveDate: '2024-03-10T13:45:00Z',
    previousBillingDate: '2024-04-01T00:00:00Z',
    newBillingDate: '2024-04-01T00:00:00Z',
    notes: 'Confirmed that current usage fits within Advanced plan limits',
    dateCreated: '2024-03-10T13:45:00Z',
    dateUpdated: '2024-03-10T13:45:00Z'
  },
  {
    id: '6',
    organizationId: sampleOrganizationDataForAccountPage.id,
    timestamp: '2024-01-05T08:30:00Z',
    changeType: 'PLAN_CHANGED' as PlanChangeType,
    previousPlanId: 'starter-plan-id',
    previousPlanName: 'Starter',
    newPlanId: 'enterprise-plan-id',
    newPlanName: 'Enterprise',
    previousPrice: '29',
    newPrice: '199',
    priceChange: '+170',
    currencyCode: 'CHF',
    billingCycle: 'Monthly',
    changedBy: 'Alex Thompson (Super Admin)',
    changedByUid: 'alex-thompson-uid',
    initiator: 'SUPER_ADMIN' as PlanChangeInitiator,
    effectiveDate: '2024-01-05T08:30:00Z',
    previousBillingDate: '2024-01-08T00:00:00Z',
    newBillingDate: '2024-02-05T00:00:00Z',
    notes: 'Upgrade includes dedicated support and custom integrations',
    dateCreated: '2024-01-05T08:30:00Z',
    dateUpdated: '2024-01-05T08:30:00Z'
  }
];

// Helper functions for plan history
export const getPlanHistoryByOrganization = (organizationId: string): PlanHistoryEntry[] => {
  return samplePlanHistoryData.filter(entry => entry.organizationId === organizationId);
};

export const getLatestPlanChange = (organizationId: string): PlanHistoryEntry | null => {
  const history = getPlanHistoryByOrganization(organizationId);
  if (history.length === 0) return null;
  
  return history.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())[0];
};

export const getPlanChangesByType = (organizationId: string, changeType: PlanChangeType): PlanHistoryEntry[] => {
  return getPlanHistoryByOrganization(organizationId).filter(entry => entry.changeType === changeType);
};

export const getPlanChangesInDateRange = (
  organizationId: string, 
  startDate: string, 
  endDate: string
): PlanHistoryEntry[] => {
  const history = getPlanHistoryByOrganization(organizationId);
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  return history.filter(entry => {
    const entryDate = new Date(entry.timestamp);
    return entryDate >= start && entryDate <= end;
  });
};

// Sample plan history statistics
export const getPlanHistoryStats = (organizationId: string) => {
  const history = getPlanHistoryByOrganization(organizationId);
  
  if (history.length === 0) {
    return {
      firstPlanDate: null,
      lastChangeDate: null,
      upgradeCount: 0,
      downgradeCount: 0,
      totalSavings: 0,
      totalCostIncrease: 0
    };
  }
  
  const sortedHistory = history.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
  const upgradeCount = history.filter(entry => entry.changeType === 'PLAN_UPGRADED').length;
  const downgradeCount = history.filter(entry => entry.changeType === 'PLAN_DOWNGRADED').length;
  
  const totalSavings = history
    .filter(entry => entry.priceChange?.startsWith('-'))
    .reduce((sum, entry) => sum + Math.abs(parseFloat(entry.priceChange || '0')), 0);
    
  const totalCostIncrease = history
    .filter(entry => entry.priceChange?.startsWith('+'))
    .reduce((sum, entry) => sum + parseFloat((entry.priceChange || '0').replace('+', '')), 0);
  
  return {
    firstPlanDate: sortedHistory[0].timestamp,
    lastChangeDate: sortedHistory[sortedHistory.length - 1].timestamp,
    upgradeCount,
    downgradeCount,
    totalSavings,
    totalCostIncrease
  };
}; 
